import { States } from "../modules/states";

export const StatesPage = () => {
  return <States />;
};
